import type { ReportFilter, ReportResponse } from '@/features/reports'

export const TREND_REPORT_ID = 12

export const TREND_DECOMPOSITION_TABS = ['volume', 'seasonal', 'trend', 'random'] as const
export type TrendDecompositionTab = (typeof TREND_DECOMPOSITION_TABS)[number]
export type TrendSeriesField = 'observed' | 'seasonal' | 'trend' | 'residual'

export interface TrendPoint {
  month: string
  search_query: string
  is_forecasted: boolean
  observed: number | null
  monthly_observed_change?: number | null
  trend: number | null
  residual: number | null
}

export const TREND_PERIODS = ['monthly', 'quarterly', 'yearly'] as const
export type TrendPeriod = (typeof TREND_PERIODS)[number]
export const TREND_MONTH_KEYS = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
] as const

export interface TrendPeriodSelection {
  period: TrendPeriod
  year: string | null
  month: number | null
  quarter: number | null
}

export interface TrendPeriodRow extends Record<string, unknown> {
  query: string
  volume: number
  change: number
}

export interface SeasonalityPoint {
  /** Locale-independent calendar month, normalised at the API boundary (BE-25-01). */
  month: number
  search_query: string
  seasonal: number | null
}

export interface TrendKeyword {
  query: string
  data: TrendPoint[]
}

export interface SeasonalityKeyword {
  query: string
  data: SeasonalityPoint[]
}

export interface TrendOverview {
  total_monthly_observed_change: number | null
  total_yearly_observed_change: number | null
  total_monthly_observed_volume: number | null
  total_yearly_observed_volume: number | null
}

export interface TrendSeasonalityPayload {
  trends: TrendKeyword[]
  seasonality: SeasonalityKeyword[]
  overview: TrendOverview
}

export interface SeasonalityResponse {
  data: unknown[]
}

export interface TrendSeasonalityReportResponse extends ReportResponse {
  trend_seasonality?: {
    seasonality: SeasonalityResponse
  }
}

export interface TrendSeasonalityRequestContext {
  accountId: number
  workspaceId: number | string
  scheduleId: number | string
  filters: readonly ReportFilter[]
}
